import ProjectSettings_ViewsAppSettings from "./project-views-app-settings"
import ProjectSettings_IntegrationEmailReply from "./integration-email-reply"
import ProjectSettings_CRM from "./crm";
import ProjectSettings_ModuleTickets from "./module-tickets"
import Project from "../../../model2/project/project"
import ApiProject from "../../../gd/api/project"


const debug = false

type IntegrationEmailSettings = {
    crmLinkContact      : boolean,
    crmCreateContact    : boolean,
    newProjectUserAccess: number
}


// potom sdelat extends SettingsProto
// import SettingsProto from "../../client-data/settings-proto";
export default class ProjectSettings {

    public project                  : Project   // link to project this settings belong to

    public summary                  : any
    public presets                  : any
    public views                    : any
    public viewsAppSettings         : ProjectSettings_ViewsAppSettings
    public defaultView              : any
    public crm                      : ProjectSettings_CRM
    public customShortId            : boolean // ??? a gde prefix
    public integrationEmail         : IntegrationEmailSettings
    public integrationEmailReply    : ProjectSettings_IntegrationEmailReply
    public moduleTickets            : ProjectSettings_ModuleTickets  // ProjectSystemType.SUPPORT_SYSTEM ticket emails
    public customView?              : any   // when project of type ProjectSystemType.VIEW it keeps custom View settings

    async save() {
        // check access
        if (!gd.ac.check.project.fullAccess(this.project.id, this.project)) {
            console.error("Error 837432 no project full access")
            return false;
        }

        debug && console.log(debug, "save()")

        return await ApiProject.saveSettings(this.project.id, this.toJSON()).promise()
    }

    constructor(sessionProject:any, data:any) {
        debug && console.log(debug, "constructor() project=",sessionProject.name, "config=",data)

        // link to project (object parent)
        this.project = sessionProject

        // first of all let's patch data
        this._patchSummary(data)
        this._patchViewsAppData(data)
        // End Patch

        // we still use it in Project Info
        this.summary            = {
            chartView       : _.get(data, 'summary.chartView', gd.const.summary.chart.BURNUP),
        }

        // presets should be removed from here in future
        this.presets            = {
            listView    : [],
            tableView   : [],
        }

        this.views              = _.get(data, 'views', null)

        // this object save appSettings for views
        // separated from this.views.view.appSettings so we could customize
        // app settings whithout customizing views itself
        // i.e. we inherit views but want to apply custom appSettings for task list for example
        // this.viewsAppSettings = _.get(data, 'viewsAppSettings', {})
        this.viewsAppSettings   = new ProjectSettings_ViewsAppSettings(this, _.get(data, 'viewsAppSettings',{}))

        // project defaultView
        this.defaultView        = _.get(data,'defaultView', null)



        this.integrationEmail       = {
            crmLinkContact      : _.get(data, 'integrationEmail.crmLinkContact', false),
            crmCreateContact    : _.get(data, 'integrationEmail.crmCreateContact', false),
            newProjectUserAccess: _.get(data, 'integrationEmail.newProjectUserAccess', false),
        }

        this.crm                    = new ProjectSettings_CRM(_.get(data, 'crm', {}), this.project)
        this.integrationEmailReply  = new ProjectSettings_IntegrationEmailReply(_.get(data, 'integrationEmailReply', {}))
        this.moduleTickets          = new ProjectSettings_ModuleTickets(_.get(data, 'moduleTickets', {}))

        // for backend to generate custom shortId
        this.customShortId  = _.get(data, 'customShortId', false)

        // custom view settings
        this.customView     = _.get(data, 'customView', undefined)

    }

    toJSON() {
        const jsonData : JSONObject = {
            summary                 : this.summary,
            presets                 : this.presets,
            views                   : this.views,
            viewsAppSettings        : this.viewsAppSettings.toJSON(),
            defaultView             : this.defaultView,
            crm                     : this.crm.toJson(),
            customShortId           : this.customShortId,
            integrationEmail        : this.integrationEmail,
            integrationEmailReply   : this.integrationEmailReply.toJson(),
            moduleTickets           : this.moduleTickets.toJson(),
            customView              : this.customView,
        }

        return jsonData
    }

    _patchSummary(config:any) {

        // patch not sure if needed
        let chartView = _.get(config,'summary.chart', null)
        if (chartView && ![gd.const.summary.chart.BURNDOWN, gd.const.summary.chart.BURNUP].includes(chartView)) {
            delete config.summary.chart
        }

    }

    _patchViewsAppData(config:any) {

        if (!config || !config.views) return

        _.forEach(config.views, projectViewConfig=>{

            if (projectViewConfig.appSettings) {
                // console.log("patch", projectViewConfig)

                // make sure we have config object
                if (!config.viewsAppSettings) config.viewsAppSettings = {}

                // check if there is no settings already set for view id
                // and if not copy settings from old projectViewConfig
                if (!config.viewsAppSettings[projectViewConfig.id])
                    config.viewsAppSettings[projectViewConfig.id] = projectViewConfig.appSettings
            }

        })

    }

}
